import type { Column } from '@innovamat/glimmer-components';
import { TableComponent } from '@innovamat/glimmer-components';
import type { Course } from '@innovamat/glow-api-client';
import type { TFunction } from 'i18next';
import {
  AdaptedPlansContainer,
  AdaptedPlansTitle,
  PrintArea,
  TableContainer,
} from '../components/common.styled';
import MessageReports from '../components/message-reports';
import ReportsLoader from '../components/reports-loader';

type Row = {
  [key: string]: any;
};

export type ReportType = 'weekly' | 'general';

export type ReportData = {
  columns: Column<Row>[];
  rows: Row[];
  id: string;
  averageRow: Row;
  courseOrder?: number | null;
};

type Props = {
  loading: boolean;
  checkReportHasData: (rows: any) => boolean;
  mainReportData: ReportData;
  adaptedReportsData: ReportData[] | undefined;
  allRows?: Row[];
  isWarningList?: boolean;
  isCurrentWeek?: boolean;
  onExpandColumn: (column: string, tableId: string) => void;
  handleSendEvent: (event: string, parameters?: {}) => void;
  t: TFunction<'translation', undefined, 'translation'>;
  handlePreviousWeek?: () => void;
  showPreviousWeekButton?: boolean;
  courses?: Course[]; // TODO: Change it to mandatory when course in general progress
  reportType: ReportType;
  handleOnClickRow?: (row: Row) => void;
};

export const renderTables = (props: Props) => {
  const {
    loading,
    checkReportHasData,
    mainReportData,
    adaptedReportsData,
    allRows,
    isWarningList,
    isCurrentWeek,
    onExpandColumn,
    handleSendEvent,
    t,
    handlePreviousWeek,
    showPreviousWeekButton,
    courses,
    reportType,
  } = props;

  const { rows, columns, averageRow, id } = mainReportData;

  const clickableRows = allRows?.map((row) => row.id);

  if (loading) return <ReportsLoader />;

  if (
    !checkReportHasData(rows) &&
    !adaptedReportsData?.some((adaptedReport: any) =>
      checkReportHasData(adaptedReport?.rows)
    )
  )
    return (
      <MessageReports
        isWarningList={!!isWarningList}
        isCurrentWeek={!!isCurrentWeek}
        onPreviousWeek={handlePreviousWeek!}
        showPreviousWeekButton={showPreviousWeekButton!}
        reportType={reportType}
      />
    );
  return (
    <PrintArea id="print-area">
      <TableContainer>
        {rows.length && averageRow && checkReportHasData(rows) && (
          <TableComponent
            rows={rows}
            columns={columns}
            firstRow={averageRow}
            onExpandColumn={onExpandColumn}
            handleSendEvent={handleSendEvent}
            clickableRows={clickableRows}
            id={id}
            topStickyOffset={64}
          />
        )}
      </TableContainer>
      <AdaptedPlansContainer>
        {adaptedReportsData?.map((adaptedReport: any) => {
          const courseName = courses?.find(
            (course) => course.order === adaptedReport.courseOrder
          )?.name;
          return (
            <>
              <AdaptedPlansTitle>
                {`${t('reports.subtitle.adaptedStudents')} ${
                  courseName ? `- ${courseName}` : ''
                }`}
              </AdaptedPlansTitle>
              <TableContainer>
                <TableComponent
                  rows={adaptedReport.rows}
                  columns={adaptedReport.columns}
                  onExpandColumn={onExpandColumn}
                  handleSendEvent={handleSendEvent}
                  clickableRows={clickableRows}
                  id={adaptedReport.id}
                  topStickyOffset={64}
                />
              </TableContainer>
            </>
          );
        })}
      </AdaptedPlansContainer>
    </PrintArea>
  );
};
